import React, { useEffect, useState } from 'react'
import { Button, Card, Descriptions, Spin, Table, Tag, message } from 'antd'
import moment from 'moment'
import { errorMessage, fetchVoucher } from './api'
import PhotoThumbs from './PhotoThumbs'
import { BASE_PATH } from './helpers'

const AcvView = ({ match, history }) => {
  const [voucher, setVoucher] = useState(null)
  const [loading, setLoading] = useState(true)
  const id = match.params.id

  useEffect(() => {
    setLoading(true)
    fetchVoucher(id)
      .then(setVoucher)
      .catch((e) => message.error(errorMessage(e, 'Failed to load voucher')))
      .finally(() => setLoading(false))
  }, [id])

  const columns = [
    { title: '#', key: 'index', width: 50, render: (text, record, index) => index + 1 },
    {
      title: 'Asset Code',
      key: 'assetCode',
      render: (r) => <span>{r.assetCode}{r.entryMode === 'QR' && <Tag className='acv-qr-tag'>QR</Tag>}</span>
    },
    {
      title: 'Condition',
      key: 'condition',
      render: (r) => r.condition ? <Tag color={r.condition.color || undefined}>{r.condition.name}</Tag> : ''
    },
    { title: 'Remark', dataIndex: 'remarks', key: 'remarks' },
    {
      title: 'Geo Location',
      key: 'geo',
      render: (r) => typeof r.latitude === 'number'
        ? (
          <span>
            <a href={`https://www.google.com/maps?q=${r.latitude},${r.longitude}`} target='_blank' rel='noopener noreferrer'>
              {r.latitude.toFixed(6)}, {r.longitude.toFixed(6)}
            </a>
            {r.geoSource === 'MAP' ? ' (map)' : ''}
          </span>
          )
        : '-'
    },
    {
      title: 'Photos',
      key: 'photos',
      render: (r) => <PhotoThumbs photos={r.photos || []} />
    },
    { title: 'Created By', key: 'createdBy', render: (r) => (r.createdBy && r.createdBy.name) || '' },
    { title: 'Created At', dataIndex: 'createdAt', key: 'createdAt', render: (v) => v && moment(v).format('DD-MM-YYYY HH:mm:ss') }
  ]

  return (
    <Spin spinning={loading}>
      <Card
        className='gx-card-metrics'
        title={voucher ? `Asset Condition Voucher - ${voucher.acvNo}` : 'Asset Condition Voucher'}
        extra={<Button className='gx-mb-0' onClick={() => history.push(BASE_PATH)}>Back</Button>}
      >
        {voucher && (
          <>
            <Descriptions bordered size='small' column={{ xs: 1, sm: 2, md: 3 }}>
              <Descriptions.Item label='ACV No'>{voucher.acvNo}</Descriptions.Item>
              <Descriptions.Item label='Date'>{moment(voucher.date).format('DD-MM-YYYY HH:mm')}</Descriptions.Item>
              <Descriptions.Item label='Location'>{voucher.location && voucher.location.name}</Descriptions.Item>
              <Descriptions.Item label='Sub Location'>{(voucher.client && voucher.client.name) || '-'}</Descriptions.Item>
              <Descriptions.Item label='Created By'>{voucher.createdBy && voucher.createdBy.name}</Descriptions.Item>
              <Descriptions.Item label='Created At'>{moment(voucher.createdAt).format('DD-MM-YYYY HH:mm:ss')}</Descriptions.Item>
            </Descriptions>
            <h4 className='acv-section-title'>Asset Conditions ({(voucher.assetConditions || []).length})</h4>
            <Table size='small' rowKey='_id' columns={columns} dataSource={voucher.assetConditions || []} pagination={false} scroll={{ x: true }} />
          </>
        )}
      </Card>
    </Spin>
  )
}

export default AcvView
